import 'urlpattern-polyfill';
import '../templates/components/wishlist-app/wishlist-app.js';
import '../templates/components/event-app-layer/event-app-layer.js';
import '../templates/components/wishlist-container/wishlist-container.js';
import '../templates/components/wishlist-collections/wishlist-collections.js';
import '../templates/components/mail-product-added/mail-product-added.js';
import '../templates/components/product-image-overlay/product-image-overlay.js';
import '../templates/components/wishlist-alert/wishlist-alert.js';
import '../templates/components/whats-new-tooltip/whats-new-tooltip.js';

import('../templates/components/scroll-to-top/scroll-to-top.js');
import { register } from 'swiper/element/bundle';
import { wishlistService } from './service/wishlist-service.js';
import { wishlistHeaderCountService } from './service/wishlist-header-count-service.js';
import { trackABTests } from '../templates/components/tracking/trackingABTest.js';

const initializeLazyCssLoading = (): void => {
  const performLazyLoad = (): void => {
    const metaElements = document.querySelectorAll<HTMLMetaElement>('meta[name="css:lazyload"]');
    metaElements.forEach((element: HTMLMetaElement) => {
      const content = element.getAttribute('content');
      const parent = element.parentElement || element.parentNode;
      if (content && parent?.contains(element)) {
        window.loadCSS(content);
        parent.removeChild(element);
      }
    });
  };
  performLazyLoad();
};

register(); // register swiper web component

wishlistHeaderCountService.init();
wishlistService.init();

trackABTests();

document.addEventListener('DOMContentLoaded', () => {
  initializeLazyCssLoading();
});
